const $$splitErrorComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(unauthenticated)/link-identity/index.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(unauthenticated)/link-identity/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
const searchSchema = z.object({
  token: z.string(),
  state: z.string().optional()
});
const supportedConnections = ['auth0', 'google-oauth2', 'email', 'samlp'] as const;
type SupportedConnections = (typeof supportedConnections)[number];
export const Route = createFileRoute('/(unauthenticated)/link-identity/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(searchSchema),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});